import { render } from "./EmpLeads.vue?vue&type=template&id=48d24c5d"
import script from "./EmpLeads.vue?vue&type=script&lang=js"
export * from "./EmpLeads.vue?vue&type=script&lang=js"

import "./EmpLeads.vue?vue&type=style&index=0&id=48d24c5d&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__